import { Injectable } from '@angular/core';
import { DataEntry } from '@osos/shared/api';
import { TimelineCategoryPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { TimelineCategoryV1ParserService } from '../../parsers/timeline-category-parser/timeline-category-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class TimelineCategoryFactoryService extends FactoryBase<
  DataEntry,
  TimelineCategoryPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: TimelineCategoryV1ParserService,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: TimelineCategoryPresenterModel): DataEntry {
    throw new Error('Method not implemented.');
  }

  createPresenterModel(model: DataEntry): TimelineCategoryPresenterModel {
    const parser = this.getParser(
      DataEntry,
      TimelineCategoryPresenterModel,
      model.specificationVersion,
    );

    const result = parser.getPresenterModel(model);
    return result;
  }
}
